import { render, staticRenderFns } from "./NutritionistePage2.vue?vue&type=template&id=634aaf3e&scoped=true&"
import script from "./NutritionistePage2.vue?vue&type=script&lang=js&"
export * from "./NutritionistePage2.vue?vue&type=script&lang=js&"
import style0 from "./NutritionistePage2.vue?vue&type=style&index=0&id=634aaf3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634aaf3e",
  null
  
)

export default component.exports